module.exports = __webpack_public_path__ + "static/media/realiance-hero-bw-2x.864e1ed0.jpg";